import React from 'react'
import classNames from 'classnames'
import useVisible from '../tmoHooks/useVisible'

import style from './Dropdown.module.css'

function Dropdown({
  triggerText,
  triggerIcon,
  className,
  theme,
  children,
  IconTitle,
  contentClass,
  testId,
  ariaLabel,
  ariaRole,
  tabIndex
}) {
  const { visibilityRef, visible, setVisible } = useVisible(false)
  const attributes = {}
  if (IconTitle) {
    attributes['title'] = IconTitle
  }

  return (
    <div
      className={classNames(
        style.container,
        visible && style.container_open,
        theme && style[theme],
        className
      )}
      data-testid={testId}
      ref={visibilityRef}
      aria-label={ariaLabel}
      role={ariaRole}
      tabIndex={tabIndex}
    >
      <span className={style.trigger} onClick={() => setVisible(!visible)}>
        {triggerText && (
          <span className={style.trigger_text}>{triggerText}</span>
        )}
        {triggerIcon && (
          <span className={style.trigger_icon} {...attributes}>
            {triggerIcon}
          </span>
        )}
      </span>
      {visible && (
        <div
          className={classNames(
            style.content,
            visible && style.content_open,
            contentClass
          )}
        >
          {children}
        </div>
      )}
    </div>
  )
}

export default Dropdown
